import { Link } from 'react-router-dom';
import ProjectCard from './ProjectCard';
import LiveFeed from './LiveFeed.tsx';
import { Button } from './ui/button';
import { useProjects } from '@/hooks';

const ProjectGrid = () => {
  const { projects, isLoading, error } = useProjects({ limit: 3 });

  return (
    <section className="w-full bg-card border-t border-border py-20 px-4 md:px-8 lg:px-20">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8">
        {/* Featured Projects - Main Content */}
        <div className="flex-1 flex flex-col gap-10">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
            <div>
              <h2 className="text-3xl font-bold text-foreground mb-2">Featured Projects</h2>
              <p className="text-muted-foreground">High-consensus ideas ready for development</p>
            </div>
            <Link 
              to="/explore"
              className="text-primary font-mono text-sm font-bold inline-flex items-center gap-1 hover:underline underline-offset-4"
            >
              VIEW ALL PROJECTS 
              <span className="material-symbols-outlined text-[16px]">arrow_forward</span>
            </Link>
          </div>
          
          {isLoading ? (
            <div className="flex justify-center items-center py-12">
              <span className="material-symbols-outlined text-4xl text-muted-foreground animate-spin">
                progress_activity
              </span>
            </div>
          ) : error ? (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <span className="material-symbols-outlined text-4xl text-muted-foreground mb-2">
                cloud_off
              </span>
              <p className="text-muted-foreground">Unable to load projects</p>
            </div>
          ) : projects.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <span className="material-symbols-outlined text-4xl text-muted-foreground mb-2">
                inbox
              </span>
              <p className="text-muted-foreground">No projects yet</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {projects.map((project) => (
                <Link key={project.id} to={`/project/${project.id}`}>
                  <ProjectCard project={project} />
                </Link>
              ))}
            </div>
          )}
        </div>

        {/* Global Discourse - Sidebar */}
        <div className="lg:w-80 flex-shrink-0">
          <div className="lg:sticky lg:top-24">
            <LiveFeed />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectGrid;
